// 客情管理
export default [
  {
    path: "/customerRelations",
    meta: { title: "客情管理" },
    component: () => import("../views/customerRelations/index.vue"),
    children: [
      {
        path: "/customerRelations/list",
        name: "customerList",
        meta: { title: "用户列表", isMenu: true },
        component: () => import("../views/customerRelations/list.vue"),
      },
      {
        path: "/customerRelations/detail/info",
        name: "customerUserDetail",
        meta: { title: "用户详情" },
        component: () => import("../views/customerRelations/detail/info.vue"),
      },
      {
        path: "/customerRelations/pushMessage",
        name: "customerPushMessage",
        meta: { title: "消息群发", isMenu: true },
        component: () => import("../views/customerRelations/pushMessage.vue"),
      },
      {
        path: "/customerRelations/detail/add",
        meta: { title: "消息内容" },
        component: () => import("../views/customerRelations/detail/add.vue"),
      },
    ],
  },
]
